import React, { useState, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { IKContext, IKUpload } from "imagekitio-react";
import { imageKitPublicKey, imageKitUrlEndpoint, uri } from "../../helper";
import "./addclass.css";

interface AddClassProps {
  handleClose: () => void;
  onAddClass: (newClass: any) => void;
  initialData?: any;
}
export default function AddClass({ handleClose, onAddClass, initialData }: AddClassProps) {
  const [classTitle, setClassTitle] = useState(initialData?.title || "");
  const [duration, setDuration] = useState(initialData?.minDuration ? `${initialData.minDuration}min` : "");
  const [shortDescription, setShortDescription] = useState(initialData?.description || "");
  const [thumbnail, setThumbnail] = useState(initialData?.thumbnailImageUrl || "");
  const [video, setVideo] = useState(initialData?.videoUrl || "");
  const [isVideoUploading, setIsVideoUploading] = useState(false);
  const [isYoutubeUpload, setIsYoutubeUpload] = useState(false);
  const thumbnailRef = useRef<any>(null);
  const videoRef = useRef<any>(null);

  const handleThumbnailBrowse = () => {
    thumbnailRef.current?.click();
  };

  const handleVideoBrowse = () => {
    videoRef.current?.click();
  };

  const handleAdd = () => {
    if (!classTitle.trim()) {
      toast.error("Please enter a class title.");
      return;
    }
    if (!duration) {
      toast.error("Please select a duration.");
      return;
    }
    if (!shortDescription.trim()) {
      toast.error("Please enter a short description.");
      return;
    }
    if (!thumbnail) {
      toast.error("Please upload a thumbnail.");
      return;
    }
    if (!video) {
      toast.error("Please upload a video.");
      return;
    }

    const minDuration = parseInt(duration.replace("min", ""), 10);
    const newClass = {
      title: classTitle,
      description: shortDescription,
      videoUrl: video,
      thumbnailImageUrl: thumbnail,
      minDuration,
      maxDuration: minDuration,
    };

    onAddClass(newClass);
    handleClose();
  };

  const onError = (e: any) => {
    setIsVideoUploading(false);
    toast.error("Upload failed.");
    
  };

  const onVideoUploadStart = () => {
    setIsVideoUploading(true);
  };

  const onVideoUploadSuccess = (res: any) => {
    setVideo(res.url);
    setIsVideoUploading(false);
  };

  return (
    <>
      <Toaster
        toastOptions={{
          style: { color: "black" },
        }}
      />
      <div className="addClass">
        <div className="fullDescClass">
          <div className="headerofAClass">
            <h3>Add Class</h3>
            <div
              className="top-svg"
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            >
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* SVG path unchanged */}
              </svg>
            </div>
          </div>
          <div className="aTile-border-top"></div>
          <div className="aClass-body">
            <div className="previous-drop">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Class Title
                </label>
                <input
                  className="form-select setFirst"
                  name="ClassTitle"
                  value={classTitle}
                  onChange={(e) => setClassTitle(e.target.value)}
                  placeholder="Enter class title"
                />
              </div>
              <div className="dropdown">
                <div className="dropdown">
                  <label className="cat-hello" htmlFor="cat">
                    Duration
                  </label>
                  <select
                    className="form-select setThird setBatchThird"
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                  >
                    <option value="">Select duration</option>
                    <option value="30min">30 minutes</option>
                    <option value="45min">45 minutes</option>
                    <option value="1hr">1 hour</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="next-step-desc">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Short Description
                </label>
                <input
                  type="text"
                  name="ShortDescription"
                  className="set-box-upload-video"
                  value={shortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                  placeholder="Enter short description"
                />
              </div>
            </div>
            <div className="next-step-desc">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Upload Thumbnail
                </label>
                <div className="uplode-image-video">
                  <IKContext
                    publicKey={imageKitPublicKey}
                    urlEndpoint={imageKitUrlEndpoint}
                    authenticationEndpoint={uri + `/challenge/auth`}
                  >
                    <IKUpload
                      fileName={`thumbnail-${Date.now()}`}
                      onError={onError}
                      onSuccess={(res: any) => setThumbnail(res.url)}
                      ref={thumbnailRef}
                    />

                    {thumbnail && (
                      <span className="set-box-upload-video">{thumbnail}</span>
                    )}
                  </IKContext>
                </div>
              </div>
            </div>
            <div className="next-step-desc">
              <div className="dropdown">
                <label className="cat-hello" htmlFor="cname">
                  Upload Video
                </label>
                <div className="video-source-toggle">
                  <label className="align-label px-2">
                    <input
                      type="radio"
                      name="videoSource"
                      checked={!isYoutubeUpload}
                      onChange={() => setIsYoutubeUpload(false)}
                    />
                    <span className="mx-2">Upload Video</span>
                  </label>
                  <label className="align-label px-4">
                    <input
                      type="radio"
                      name="videoSource"
                      checked={isYoutubeUpload}
                      onChange={() => setIsYoutubeUpload(true)}
                    />
                    <span className="mx-2">YouTube URL</span>
                  </label>
                </div>
                <div className="uplode-image-video">
                  {!isYoutubeUpload ? (
                    <IKContext
                      publicKey={imageKitPublicKey}
                      urlEndpoint={imageKitUrlEndpoint}
                      authenticationEndpoint={uri + `/challenge/auth`}
                    >
                      <IKUpload
                        fileName={`video-${Date.now()}`}
                        onError={onError}
                        onSuccess={onVideoUploadSuccess}
                        onUploadProgress={onVideoUploadStart}
                        ref={videoRef}
                      />

                      {isVideoUploading ? (
                        <span className="set-box-upload-video">
                          <span className="spinner"></span>Uploading...
                        </span>
                      ) : video ? (
                        <span className="set-box-upload-video">{video}</span>
                      ) : (
                        <span className="set-box-upload-video">No video selected</span>
                      )}
                    </IKContext>
                  ) : (
                    <input
                      type="text"
                      className="set-box-upload-video form-control"
                      value={video}
                      onChange={(e) => setVideo(e.target.value)}
                      placeholder="Enter YouTube URL (e.g., https://www.youtube.com/watch?v=xyz)"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="drag-drop-top-line"></div>
          <div className="down-buttons d-flex">
            <button className="create-button" onClick={handleAdd}>
              Add Class
            </button>
            <button className="cancel-button" onClick={handleClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}